import "./roadmap.css"
import progressImg from "../../../assets/img/other/inProgress.svg"
import techVisionImg from "../../../assets/img/other/techVision.svg"
import { Step } from "./Step"
import PrimaryAnchorBtn from "../../common/Anchors/PrimaryAnchorBtn"

export function Roadmap() {
  const roadmapSteps = [
    {
      timing: "Delivered in 2026",
      title: "Equipment and stock, together",
      description: "We've integrated stock-track into equi-track, bringing equipment, parts and consumables together, including complete stock management for ordering, receiving and using parts and consumables on jobs. One connected system, from quotation to delivery.",
      icon: "ai-tool"
    },
    {
      timing: "October 2026",
      title: "Continuously strengthening security",
      description: "Protecting your data is an ongoing priority. Working with a specialist security company in North East Scotland, we're further strengthening security across equi-track to maintain robust protection as the system grows.",
      icon: "ai-database"
    },
    {
      timing: "Coming November 2026",
      title: "Multi-site management",
      description: "Multiple sites. One connected business. Manage equipment, stock, jobs and quotations by site, share equipment and stock across your organisation, and keep a clear view of the whole company.",
      icon: "ai-globe"
    },
    {
      timing: "Planned for 2027",
      title: "Maintenance dashboards that drive action",
      description: "See what needs attention, what's due next and which equipment is ready to work. From the end of 2026, we're working directly with customers to design visual dashboards and reporting that help teams prioritise maintenance and stay ahead of requirements.",
      icon: "ai-activity"
    },
    {
      timing: "Planned for 2027",
      title: "Ask your data. Get useful answers.",
      description: "We're developing intelligent data analysis using automation to help you get answers from your equi-track data. Ask everyday operational questions, uncover useful insights and spend less time searching through reports.",
      icon: "ai-chart"
    }
  ]
  return (
    <main className="below-navbar card border-0 mb-4" id="steps-icons">
      <div className="container w-100 pb-md-2 pt-lg-2 pb-lg-4 py-xl-4 py-xxl-5">
        <h1 className="mb-n2 pt-5 text-center">Roadmap</h1>
        <p className="py-3 text-center">Developed by our team. Shaped by our customers. See what we're delivering in 2026 and where we're heading next.</p>
        <div className="card-body mt-3 d-flex">
          <div className="steps steps-hoverable">
            {roadmapSteps.map((step) => {
              return <Step key={step.title} step={step} />
            })}
          </div>
          <div className="d-flex flex-column justify-content-around">
            <img className="img-fluid progress-img mx-5" src={progressImg} alt="" />
            <img className="img-fluid progress-img mx-5" src={techVisionImg} alt="" />
          </div>
        </div>
        <section className="roadmap-feedback rounded-3 p-4 p-md-5 mt-5" aria-labelledby="roadmap-feedback-heading">
          <h2 id="roadmap-feedback-heading">Your priorities shape our roadmap</h2>
          <p>We're introducing easier ways to share ideas and requests directly through equi-track. Structured feedback will help our development team review needs faster, identify shared priorities and turn customer insight into practical improvements throughout 2027.</p>
          <div className="border-top pt-4 mt-4">
            <h3 className="h4">Help design the dashboards your business needs</h3>
            <p>Considering equi-track? Work directly with our development team to help shape maintenance dashboards around your processes, priorities and reporting needs, as part of the equi-track package.</p>
            <p className="small">Tell us you'd like to join the maintenance dashboard discussions when you get in touch.</p>
            <PrimaryAnchorBtn title="Help shape our dashboards" path="/#contact" />
          </div>
        </section>
        <section className="text-center mt-5" aria-labelledby="roadmap-demo-heading">
          <h2 className="h3" id="roadmap-demo-heading">See what equi-track can do for your business today</h2>
          <p>Book a TEAMS demonstration, or let us know if you'd prefer to meet in person.</p>
          <PrimaryAnchorBtn title="Book a demonstration" path="/#contact" />
        </section>
      </div>
    </main>
  )
}
